import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  height: 50px;
  padding: 8px;
`;
